module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _vm._t("loading") : _vm._e(), _vm._v(" "), _c('div', {
    ref: "container",
    attrs: {
      "id": "viewerContainer"
    }
  }, [_c('div', {
    staticClass: "pdfViewer",
    attrs: {
      "id": "viewer"
    }
  }), _vm._v(" "), _c('resizeSensor', {
    attrs: {
      "initial": true
    },
    on: {
      "resize": _vm.resizeScale
    }
  })], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e6366ffe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/pdfvuer/src/Pdfvuer.vue
// module id = 967
// module chunks = 170